import React, { useState } from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import CategoryMenuDropdown from './CategoryMenuDropdown';
import MobileMenuDrawer from './MobileMenuDrawer';
import { useMobileDimensions } from '@app/hooks';

const MenuWrapper = styled.div`
  position: relative;
`;

const MenuButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.556px;
  gap: 3.556px;
  width: 32px;
  height: 32px;
  border: 1px solid #8d8d8d;
  border-radius: 10px;
  background: ${(props) =>
    props.$isOpen ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0,0,0, 0.1)'};
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  /* Desktop styles - keep original design */
  @media (min-width: 769px) {
    width: 36px;
    height: 36px;
    padding: 4px;
    gap: 4px;
    border: 1px solid #8d8d8d;
    border-radius: 12px;
  }
`;

const CategoryMenu: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const { isMobile } = useMobileDimensions();

  const handleToggleDropdown = () => {
    if (isMobile) {
      setIsMobileDrawerOpen(!isMobileDrawerOpen);
    } else {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleCloseMobileDrawer = () => {
    setIsMobileDrawerOpen(false);
  };

  if (isMobile) {
    return (
      <MenuWrapper>
        <MenuButton
          $isOpen={isMobileDrawerOpen}
          onClick={handleToggleDropdown}
        >
          <MenuIcon />
        </MenuButton>
        <MobileMenuDrawer
          isOpen={isMobileDrawerOpen}
          onClose={handleCloseMobileDrawer}
        />
      </MenuWrapper>
    );
  }

  return (
    <Popover
      content={<CategoryMenuDropdown onClose={handleCloseDropdown} isOpen={isDropdownOpen}/>}
      trigger="click"
      open={isDropdownOpen}
      onOpenChange={setIsDropdownOpen}
      placement="bottomLeft"
      arrow={false}
      destroyTooltipOnHide
      overlayStyle={{ marginTop: 4 }}
      overlayInnerStyle={{ padding: 0, background: 'transparent' }}
    >
      <MenuButton $isOpen={isDropdownOpen}>
        <MenuIcon />
      </MenuButton>
    </Popover>
  );
};

export default CategoryMenu;

const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.0004 6.6738C21.0004 8.7024 19.3552 10.3476 17.3266 10.3476C15.298 10.3476 13.6537 8.7024 13.6537 6.6738C13.6537 4.6452 15.298 3 17.3266 3C19.3552 3 21.0004 4.6452 21.0004 6.6738Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3467 6.6738C10.3467 8.7024 8.7024 10.3476 6.6729 10.3476C4.6452 10.3476 3 8.7024 3 6.6738C3 4.6452 4.6452 3 6.6729 3C8.7024 3 10.3467 4.6452 10.3467 6.6738Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.0004 17.2619C21.0004 19.2905 19.3552 20.9348 17.3266 20.9348C15.298 20.9348 13.6537 19.2905 13.6537 17.2619C13.6537 15.2333 15.298 13.5881 17.3266 13.5881C19.3552 13.5881 21.0004 15.2333 21.0004 17.2619Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3467 17.2619C10.3467 19.2905 8.7024 20.9348 6.6729 20.9348C4.6452 20.9348 3 19.2905 3 17.2619C3 15.2333 4.6452 13.5881 6.6729 13.5881C8.7024 13.5881 10.3467 15.2333 10.3467 17.2619Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
